import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { WorkflowApiKeySchema } from "../../../utils/validations";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { useEffect } from "react";
import {
  selectSelectedWorkflowApiKey,
  selectWorkflowsApiKeysActionLoading,
  selectShowEditorModal,
  handleHideEditorModal,
  getWorkflowsApiKeysAsync,
  updateWorkflowApiKeyAsync,
  createWorkflowApiKeyAsync,
} from "../../../store/workflows/apiKeysSlice";
import { Input, Button, Modal } from "djuno-design";

const WorkflowApiKeyEditorModal = () => {
  const isOpen = useAppSelector(selectShowEditorModal);
  const loading = useAppSelector(selectWorkflowsApiKeysActionLoading);
  const apiKey = useAppSelector(selectSelectedWorkflowApiKey);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(WorkflowApiKeySchema),
  });

  useEffect(() => {
    if (isOpen && apiKey) {
      setValue("keyName", apiKey.keyName);
    }
  }, [isOpen, apiKey, setValue]);

  const onSubmit = (data: any) => {
    if (apiKey) {
      dispatch(
        updateWorkflowApiKeyAsync({
          id: apiKey.id,
          keyName: data.keyName,
        })
      ).then((action) => {
        if (action.type === "workflows/api-keys/update/fulfilled") {
          reset();
          dispatch(handleHideEditorModal());
          dispatch(getWorkflowsApiKeysAsync());
        }
      });
    } else {
      dispatch(createWorkflowApiKeyAsync(data.keyName)).then((action) => {
        if (action.type === "workflows/api-keys/create/fulfilled") {
          reset();
          dispatch(handleHideEditorModal());
          dispatch(getWorkflowsApiKeysAsync());
        }
      });
    }
  };

  useEffect(() => {
    return () => {
      dispatch(handleHideEditorModal());
    };
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        dispatch(handleHideEditorModal());
        reset();
      }}
      contentClassName="max-w-lg"
      //   containerClassName="!items-start"
      title={apiKey ? "Update API key" : "Create new API key"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 flex flex-col w-full gap-5">
          <Input
            label="API key label"
            {...register("keyName")}
            error={errors.keyName?.message}
            placeholder=""
            required
          />
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            loading={loading}
            uiType="primary"
            disabled={loading}
            type="submit"
            className="w-[100px]"
          >
            {apiKey ? "Update" : "Create"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default WorkflowApiKeyEditorModal;
